module.exports = __webpack_public_path__ + "static/gray-and-lilac-master-bedroom-PKZE7LQ-9421757e7ffe03b94e623fed37c05475.jpg";